export default function () {
    // QuickView
    $('.js-carousel-select-color-quickview').slick({
        slidesToShow: 6,
        slidesToScroll: 2,
        infinite: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 10,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 2
                }
            }
        ]

    });
}
